import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import WDPContext from 'WDPContext';
import config from 'cfg';
import fetch from 'isomorphic-fetch';
import urllib from 'url';
import UI from 'UI';
import cx from 'classnames';

import CATEGORIES from '../widgetCategories';

function checkStatus(response) {
    console.log('STATUS', response.status);
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function parseJSON(response) {
    return response.json();
}

class BaseWidget extends React.Component {
    constructor(props, context) {
        super(props, context);
        var initState = props.initState || {};

        this.state = _.assign(
            {
                initState: !_.isEmpty(initState) && !initState.failed,
                load: { failed: false, reqQueue: 0 },
                loaded: false,
            },
            initState,
        );
        this.i18dict = {};
        this.i18CommonDict = RCore.i18Register(
            require('../../i18/default/i18.Common'),
            require('../../i18/i18.Common'),
            {},
        );
        this.i18 = RCore.i18.bind(this);
    }

    componentDidMount() {
        //If this is video widget
        // if init state is empty -> try to load

        if (!this.state.initState) {
            this._loadDataRequest = this.loadData()
                .then(res => {
                    res.loaded = true;
                    this.setState(res);
                })
                .catch(res => {
                    res.failed = true;
                    this.setState(res);
                });
        }

        if (this.video) {
            this.addAnimationListeners();
        }

        if (this.state.initState && this.video && this.state.loaded) {
            this.prepareAnimation();
            this.revealContent();
        } else if (this.video && !this.timeline && this.props.startAnimation) {
            this.dispatchStartAnimationEvent();
        }

        // subscribe for screen shange updates
        if (this.context.screenSizeObserver) {
            this.context.screenSizeObserver.subscribe(() => this.forceUpdate());
        }

        this._debounceMesureHeight = _.debounce(this.mesureHeight.bind(this), 3000);
        window.addEventListener('resize', this._debounceMesureHeight, false);

        // to do unmount

        this.mesureHeight();
        this.trackPageView();
    }

    componentWillReceiveProps(newProps) {
        // CAUTION: can break the state
        if (newProps.initState !== this.props.initState) {
            this.setState(newProps.initState);
        }

        const ppTypes = _.get(this, 'constructor.spec.propTypes', []);
        const requiredParamWasChanged = _.filter(
            ppTypes,
            pp =>
                ((pp.required || pp.loader) && newProps[pp.key] !== this.props[pp.key]) ||
                (pp.propsMap && _.find(_.values(pp.propsMap), pm => newProps[pm] !== this.props[pm])),
        );

        if (requiredParamWasChanged.length) {
            if (this.video && this.props.noAnimationControls) {
                //This is made for AnimatedTournamentTable;
                //Otherwise when parameters are changed, it animates like a mess
                // window.location.reload();
                // return;
            }

            this.setState(
                {
                    __r: Math.random(),
                    loaded: false,
                    __status: null,
                    animationStarted: false,
                },
                () => {
                    this.reLoadData();
                },
            );
        }

        if (newProps.tempTemplate) {
            this.setState({ template: newProps.tempTemplate });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof window === 'undefined') return;
        this.mesureHeight();

        if (!prevState.__status && this.state.__status && this.state.__status.error) {
            if (this.props.onError) this.props.onError(this.state.__status);
        }

        if (prevState.loaded === false && this.state.loaded === true && !this.state.__status) {
            if (this.props.onOk) this.props.onOk('GOOD');
        }

        if (prevState.__status && prevState.__status.error === true && !this.state.__status) {
            if (this.props.onOk) this.props.onOk('GOOD');
        }
        if (this.video && !prevState.loaded && this.state.loaded) {
            this.resetAnimation();
            this.prepareAnimation();
            this.revealContent();
        }
    }

    componentWillUnmount() {
        if (this._debounceMesureHeight && this._debounceMesureHeight.cancel) this._debounceMesureHeight.cancel();
        if (this._loadDataRequest) {
            // cancel promise
            console.log('TBD - cancel promise to implement', this._loadDataRequest);
            // this._loadDataRequest.reject("UNMOUNTED");
        }
        if (this.video && this.animation) {
            this.pauseAnimation();
            this.removeAnimationListeners();
        }
        window.removeEventListener('resize', this._debounceMesureHeight, false);
    }

    resetAnimation = () => {
        if (!this.animation) return;
        this.animation.pause();
        this.animation.reset();
        window.dispatchEvent(new Event('resetAnimation'));
    };

    revealContent = () => {
        if (!process.env.BROWSER) return;
        const element = document.querySelector('.sm-wdp__container');
        if (!element) return;
        element.style.visibility = 'visible';
    };

    /* TO BE REFACTORED */
    getLayoutType = () => {
        if (this.props.layoutType) return this.props.layoutType;

        if (this.props.variation)
            return _.get(
                this.state.template,
                `theme.variations.${this.constructor.spec.id}.${this.props.variation}.widgetProps.layoutType`,
                'default',
            );
        return _.get(this.state.template, `widgetProps.${this.constructor.spec.id}.layoutType`, 'default');
    };

    addAnimationListeners = () => {
        window.addEventListener('startAnimation', this.startAnimation, false);
        window.addEventListener('pauseAnimation', this.pauseAnimation, false);
        window.addEventListener('playAnimation', this.playAnimation, false);
        window.addEventListener('restartAnimation', this.restartAnimation, false);
    };

    removeAnimationListeners = () => {
        window.removeEventListener('startAnimation', this.startAnimation, false);
        window.removeEventListener('pauseAnimation', this.pauseAnimation, false);
        window.removeEventListener('playAnimation', this.playAnimation, false);
        window.removeEventListener('restartAnimation', this.restartAnimation, false);
    };

    setPState = data => {
        return new Promise((resolve, reject) => {
            this.setState(data, resolve);
        });
    };

    loadData() {
        // eslint-disable-next-line
        return RCore.PromiseProps({});
    }
    reLoadData() {
        if (this._loadDataRequest) {
            // wait if current loadData is in progress, let it finish. reload data once again
            return this._loadDataRequest.then(() => {
                return (this._loadDataRequest = this.loadData()
                    .then(this.setPState)
                    .then(() => {
                        this._loadDataRequest = null;
                    }));
            });
        } else {
            this._loadDataRequest = this.loadData()
                .then(this.setPState)
                .then(() => {
                    this._loadDataRequest = null;
                });

            return this._loadDataRequest;
        }
    }

    smRenderEmpty = () => {
        if (this.state.__status) {
            return (
                <div
                    style={{
                        textAlign: 'center',
                        padding: 15,
                        backgroundColor: '#fff',
                        color: '#000',
                        width: 800,
                    }}
                >
                    Status: {this.state.__status.message}
                </div>
            );
        }
        return <div />;
    };

    trackPageView() {
        // eslint-disable-next-line
        WDPContext.trackPageView.call(this);
    }

    trackEvent(cat, act, lab) {
        // eslint-disable-next-line
        this.context.trackEvent.call(this, cat, act, lab);
    }

    handleScreenSizeUpdate() {
        var width = ReactDOM.findDOMNode(this).offsetWidth;
        this.screenSizeObserver.onUpdateWidth(width);
    }

    fetch(url, query = {}, params = {}) {
        let { client, lang, nautre } = this.context.info || {};
        client = client || 'core';
        // client = 'spdk';
        var _url = urllib.parse(url, true);
        _url.query = _.extend(_url.query, { locale: lang }, _.omitBy(query, _.isNil));
        _url.search = null;

        url = urllib.format(_url);

        // console.log(`WIDGET REQUEST: ${url}`);

        params.headers = {
            Accept: 'application/json',
            'application-name': `dk.releaze.livecenter.${client}`,
            'Accept-Language': lang,
            //'User-Agent': 'Chrome',
        };
        var load = this.state.load;
        load.reqQueue++;
        if (!load.failed) {
            // GOOD IDEA, but  ReactDOM.findDOMNode fails when widgt was unmounted...
            // console.log("TTT", this)
            // var componentNode = ReactDOM.findDOMNode(this);
            // load.lastOKStateHeight = componentNode && componentNode.offsetHeight;
        }

        return this.setPState({ load }).then(() => {
            // console.log(">> " + this.state.load.reqQueue, url, params);
            return fetch(url, params)
                .then(checkStatus)
                .then(parseJSON)
                .then(res => {
                    // console.log(url)
                    var load = this.state.load;
                    load.reqQueue--;
                    load.failed = false;
                    load.exception = null;
                    this.setState(load);
                    return res;
                })
                .catch(res => {
                    load.reqQueue--;
                    load.failed = true;
                    load.exception = res;
                    this.setState(load);
                    return {
                        error: true,
                        exception: res,
                    };
                });
        });
    }

    mesureHeight = () => {
        var componentNode = ReactDOM.findDOMNode(this);
        var height = componentNode && componentNode.offsetHeight;
        var width = componentNode && componentNode.offsetWidth;
        var data = {
            height: height || document.body.offsetHeight,
            width: width || document.body.offsetWidth,
            url: window.location.href,
            from: 'wdp',
        };
        if (typeof document !== 'undefined' && typeof parent !== 'undefined' && window.self !== window.top) {
            var domain = document.referrer;
            if (domain && data && parent && parent.postMessage) {
                try {
                    parent.postMessage(JSON.stringify(data), domain);
                } catch (e) {
                    //
                }
            }
        }
        // post to window
        try {
            const mkey = `${width}_${height}`;
            if (mkey != this._mkey) {
                this.props.onMeasure && this.props.onMeasure(width, height);
                window.postMessage(JSON.stringify(data), location.protocol + '//' + location.host);
                this._mkey = mkey;
            }
        } catch (e) {
            //
        }
    };

    dispatchStartAnimationEvent() {
        if (!process.env.BROWSER || this.state.animationStarted) return;
        window.dispatchEvent(new Event('startAnimation'));
    }

    prepareAnimation(start) {
        if (!this.timeline) return;

        let { screencast, startAnimation } = this.props;
        startAnimation = startAnimation || start;
        this.setState({ hidedForAnimation: true }, () => {
            const showPreviewFrame = !screencast && !startAnimation;

            if (!this.timeline) return;
            this.anime = this.anime || require('animejs');
            this.anime.speed = +this.props.asm;
            this.animation =
                this.animation ||
                this.anime.timeline({
                    loop: false,
                    autoplay: false,
                    complete: () => {
                        window.dispatchEvent(new Event('animationCompleted'));
                    },
                });

            //when widget use some stages
            if (this.animation.children.length) {
                this.animation.children = [];
                this.animation.reset();
            }

            this.buildTimeline().forEach(t => this.animation.add(t));
            this.animation.seek(showPreviewFrame ? (this.getTimeline().find(t => t.previewFrame) || {}).time || 2 : 2);

            if (startAnimation) {
                this.dispatchStartAnimationEvent();
            }
        });
    }

    getTimeline = (sliceFrom, sliceTo) => {
        let timeline = (typeof this.timeline === 'function' ? this.timeline() : this.timeline) || [];
        timeline = timeline.slice(sliceFrom, sliceTo);
        return timeline;
    };

    buildTimeline = (sliceFrom, sliceTo) => {
        const builtTimeline = [];
        const timeline = this.getTimeline(sliceFrom, sliceTo);

        timeline.forEach(position => {
            const { time, elements, duration, easing } = position;
            (elements || []).forEach(el => {
                const { targets, properties } = el;
                builtTimeline.push({
                    targets,
                    duration,
                    easing,
                    offset: time,
                    ...properties,
                });
            });
        });

        return builtTimeline;
    };

    startAnimation = () => {
        if (this.state.animationStarted) return;
        this.setState(
            {
                animationStarted: true,
            },
            () => {
                if (this.video && this.timeline) {
                    if (this.props.screencast) {
                        // this.animation.seek(1);
                        this.animation.play();
                    } else {
                        this.animation.restart();
                    }
                }
            },
        );
    };

    pauseAnimation = () => {
        if (!this.animation) return;
        this.animation.pause();
    };

    playAnimation = () => {
        if (!this.animation) return;
        return this.state.animationStarted ? this.animation.play() : this.dispatchStartAnimationEvent();
    };

    restartAnimation = () => {
        if (!this.animation) return;
        this.setState(
            {
                animationStarted: false,
            },
            () => {
                this.prepareAnimation(true);
            },
        );
    };

    static defaultRequestHandler(response) {
        if (response.status >= 200 && response.status < 300) {
            var wrappedResult = {
                load: { failed: false, status: response.status },
                response: response.json(),
            };
            if (this.setState) this.setState(wrappedResult);
            return wrappedResult;
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            error.status = response.status;
            throw error;
        }
    }
    static(err) {
        var res = {
            load: {
                failed: true,
                status: err.status,
                err: err.response,
                stack: err.stack + '',
            },
        };
        if (this.setState) this.setState(res);
        return res;
    }
    renderExplain() {
        return (
            <div>
                <pre>
                    <p>Context</p>
                    {JSON.stringify(this.context, null, 4)}
                    <p>Props</p>
                    {JSON.stringify(this.props, null, 4)}
                    <p>State</p>
                    {JSON.stringify(this.state, null, 4)}
                </pre>
            </div>
        );
    }
    renderEmptyMessage = msg => {
        return <div className="wdp-widget__empty_message">{msg}</div>;
    };
    renderFailedState = load => {
        const { debug, theme } = this.props;

        return (
            <div className={`wdp wdp_${theme}`}>
                <BaseWidget.BaseBarWrap
                    {...this.props}
                    load={load}
                    className={cx('wdp-widget wdp-widget__failed')}
                    title="Loading error"
                    defaultHeight={load.lastOKStateHeight}
                >
                    <div className="wdp-content">
                        {debug && (
                            <div>
                                <p>WIDGET FAILED TO LOAD BECAUSE OF INTERNAL EXCEPTION</p>
                                <p>If You see that message - You are in debug mode. Please turn off for production</p>
                                <pre>
                                    STACK:
                                    <br />
                                    {load && load.exception && load.exception.stack}
                                </pre>
                            </div>
                        )}

                        <p className="tac">
                            <button
                                onClick={() => {
                                    this.reLoadData();
                                }}
                            >
                                Reload
                            </button>
                        </p>
                    </div>
                </BaseWidget.BaseBarWrap>
            </div>
        );
    };
}

BaseWidget.childContextTypes = {
    info: PropTypes.object,
    deeplinker: PropTypes.object,
    screenSizeObserver: PropTypes.object,
};

BaseWidget.defaultProps = {
    client: 'core',
    user: 'default',
};

class BaseBarWrap extends React.Component {
    static defaultProps = {
        moreButtonLabel: null,
        moreButtonUrl: null,
        suppressHeader: false,
        clientStyling: false,
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
    };

    render() {
        const { client, user, theme, name } = this.context.info;
        var params = _.omit(this.props, [
            'children',
            'client',
            'user',
            'theme',
            'name',
            'className',
            'initState',
            'load',
            'title',
            'style',
        ]);
        // HOW TO GET RIGHT PARAMS???
        var {
            moreButtonUrl,
            moreButtonLabel,
            load,
            title,
            customTitle,
            suppressHeader,
            defaultHeight,
            disclaimer,
            debug,
        } = this.props;

        return (
            <div className={`wdp wdp_${theme}`}>
                <div
                    className={cx(this.props.className, {
                        'wdp-widget-loading': load && load.reqQueue,
                    })}
                    style={{ minHeight: defaultHeight && defaultHeight + 'px' }}
                >
                    {!suppressHeader &&
                        (!_.isEmpty(customTitle) || !_.isEmpty(title)) && (
                            <UI.WidgetHeader title={customTitle || title} />
                        )}
                    {this.props.children}

                    {moreButtonUrl &&
                        moreButtonLabel && (
                            <div className="wdp-see-more">
                                <a href={moreButtonUrl} className="wdp-btn wdp-btn-primary">
                                    <span>{moreButtonLabel}</span>
                                </a>
                            </div>
                        )}
                    {debug && (
                        <div className="wdp-debug-info">
                            <p>{`env: ${config.build.env} hash: ${config.build.git.hash} v:${
                                config.widgets.version
                            } l: ${config.widgets.libversion}`}</p>
                            <a target="_blank" href={config.WDPLinkr.widget.iframe(client, user, theme, name, params)}>
                                {config.WDPLinkr.widget.iframe(client, user, theme, name, params)}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

var GA_EVENTS = {};
GA_EVENTS.ODDS = 'ODDS';
GA_EVENTS.ODDS_SINGLE_DEEPLINK = 'SINGLE_DEEPLINK';
GA_EVENTS.ODDS_BETTINGSLIP_ADD_BET = 'BS_ADD_BET';
GA_EVENTS.ODDS_BETTINGSLIP_DEEPLINK = 'BS_DEEPLINK';

BaseWidget.GA_EVENTS = GA_EVENTS;

BaseWidget.CATEGORIES = CATEGORIES;

BaseBarWrap.spec = {
    propTypes: [
        {
            key: 'moreButton',
            type: 'more_button_picker',
            scope: 'common',
            propsMap: {
                moreButtonLabel: 'moreButtonLabel',
                moreButtonUrl: 'moreButtonUrl',
            },
        },
        {
            key: 'customTitle',
            type: 'widget_header_picker',
            scope: 'common',
            propsMap: {
                customTitle: 'customTitle',
                suppressHeader: 'suppressHeader',
            },
        },
    ],
};
BaseWidget.BaseBarWrap = BaseBarWrap;

BaseWidget.spec = {
    propTypes: [
        {
            key: 'theme',
            type: 'theme_picker',
            scope: 'common',
        },
        {
            key: 'defaultHeight',
            type: 'hidden',
        },
        {
            key: 'lang',
            type: 'select_picker',
            label: 'Language',
            scope: 'common',
            options: [
                {
                    text: 'English',
                    value: 'en',
                },
                {
                    text: 'Danish',
                    value: 'da',
                },
                {
                    text: 'Norwegian',
                    value: 'no',
                },
            ],
        },
        {
            key: 'debug',
            label: 'Set debug mode',
            type: 'boolean',
            scope: 'common',
            defaultValue: false,
        },
    ],
};

BaseWidget.extendSpec = function(id, defs, additionalPropTypes = [], prop = {}, demo = []) {
    let spec = _.cloneDeep(this.spec);
    spec.id = id;

    Object.keys(defs || {}).map(k => {
        const prop = spec.propTypes.find(prop => prop.key == k);
        if (prop) prop.defaultValue = defs[k];
    });

    const uniquePropTypes = spec.propTypes.filter(prop => !_.find(additionalPropTypes, { key: prop.key }));
    spec.propTypes = [...uniquePropTypes, ...(additionalPropTypes || [])];

    if (demo.length) spec.demo = [...demo];

    spec = { ...spec, ...prop };

    return spec;
};

// function withLayout(WrappedComponent) {
//     return class extends BaseWidget {

//         constructor(props) {
//             super(props);
//         }

//         static contextTypes = {
//             info: PropTypes.object,
//             moment: PropTypes.func
//         }
//         // Wrapped component...
//         loadData = () => {

//             return RCore.promseProps({
//                 template: Reflect.apply(templateLoadData, this, []),
//                 widget: Reflect.apply(WrappedComponent.prototype.loadData, this, {})
//             })
//         }
//         render() {
//             console.log()
//             return <WrappedComponent {...this.props} layoutType={"2_columns"} />
//         }
//     };
// }
// let LineupPitchSMWidget = withLayout(Widget)

export { BaseBarWrap };
export default BaseWidget;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/core/BaseWidget.js
 **/